import { DialogTitle, DialogContent, IconButton, Grid } from '@mui/material';
import { Close } from '@mui/icons-material';
import React from 'react';
import { AppContext } from '../../context/AppContext';

export const ViewImage = (props: any) => {
  let myContext = React.useContext(AppContext);

  function handleClose() {
    myContext.setDialog({ open: false });
  }

  return (
    <>
      <DialogTitle sx={{ margin: 0, padding: 2 }}>
        <Grid container sx={{ flexDirection: 'row' }}>
          {props?.title || 'Image'}
        </Grid>
        <IconButton
          onClick={handleClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: theme => theme.palette.grey[500] }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}
      >
        <img
          //crossOrigin="anonymous"
          src={props?.imgUrl}
          alt={props?.label || 'Enlarged Image'}
          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
        />
      </DialogContent>
    </>
  );
};
